import React, { useEffect, useState } from "react";
import Layout from "~/Layout";
import * as dateFns from "date-fns";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import { enUS } from "date-fns/locale";
import "react-big-calendar/lib/css/react-big-calendar.css";
import MyCalendarEvent from "./components/MyCalendarEvent";
import styles from "./my-calendar.module.scss";
import useMyCalendar from "./useMyCalendar";
import MyCalendarToolbar from "./components/MyCalendarToolbar";
import EventDetailCalender from "./components/EventDetailCalender";
import "./my-calender.scss";
import EventList from "./components/EventList";
import CustomMultiSelectDropdown from "~/components/CustomMultiSelectDropdown";
import EventDetailCalenderPayrollPlus from "./components/EventDetailCalenderPayrollPlus";

const localizer = dateFnsLocalizer({ ...dateFns, locales: { "en-US": enUS } });
const MyCalendar = () => {
  const {
    items,
    onDateChange,
    calendarLoading,
    isOpen,
    handleSelectEvent,
    eventDetail,
    handleCloseEventDetailCalander,
    showEventList,
    handleViewMoreEvent,
    sidebarBackBtn,
    selectedKeys,
    setSelectedKeys,
    filterOptions,
    chipData,
    handleRemoveFilter,
    handleChipData,
    setEventItems,
    fetchEvents,
    selectedEvents,
    handleSelectNode,
    taskSelected,
  } = useMyCalendar();

  const [toolbarButtonsWidth, setToolbarButtonsWidth] = useState(0);

  const handleApplyFilter = async () => {
    handleChipData(selectedKeys);
  };

  const handleDeSelect = () => {
    taskSelected.current = false;
    setSelectedKeys({});
    setEventItems([]);
    handleChipData({});
  };
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--toolbar-right",
      `${toolbarButtonsWidth + 23}px`,
    );
  }, [toolbarButtonsWidth]);

  const EventComponentWrapper = ({ event }) => {
    const [visibleDates, setVisibleDates] = React.useState({});
    const dateKey = new Date(event.start).toDateString();

    const groupedEventsRef = React.useRef({});

    if (!groupedEventsRef.current[dateKey]) {
      groupedEventsRef.current[dateKey] = items
        .filter((e) => new Date(e.start).toDateString() === dateKey)
        .sort((a, b) => new Date(a.start) - new Date(b.start));
    }

    const groupedEvents = groupedEventsRef.current[dateKey];
    const isVisible = visibleDates[dateKey];
    const visibleEvents = groupedEvents.slice(0, 2);
    const hiddenCount = event.totalCount - visibleEvents.length;

    if (groupedEvents[0].id !== event.id) return null;

    const showMoreHandler = async () => {
      setVisibleDates((prev) => ({ ...prev, [dateKey]: true }));
      const date = new Date(dateKey);
      await fetchEvents({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        filters: chipData,
      });
      handleViewMoreEvent();
    };

    return (
      <div className={styles["events-wrapper"]}>
        {visibleEvents.map((e) => (
          <MyCalendarEvent
            key={e.id}
            {...e}
            handleSelectEvent={handleSelectEvent}
          />
        ))}
        {!isVisible && hiddenCount > 0 && (
          <p className={styles["show-more"]} onClick={showMoreHandler}>
            +{hiddenCount} View more
          </p>
        )}
      </div>
    );
  };
  return (
    <Layout
      title="My Calendar"
      toggle={isOpen}
      overlap={true}
      SideNavSection={() => {
        return showEventList ? (
          <EventList
            events={selectedEvents}
            handleSelectEvent={handleSelectEvent}
            handleCloseEventDetailCalander={handleCloseEventDetailCalander}
          />
        ) : eventDetail?.label === "Payroll +" ? (
          <EventDetailCalenderPayrollPlus
            eventDetail={eventDetail}
            handleCloseEventDetailCalander={handleCloseEventDetailCalander}
            backBtn={sidebarBackBtn}
            handleViewMoreEvent={() => {
              handleViewMoreEvent();
            }}
          />
        ) : (
          <EventDetailCalender
            eventDetail={eventDetail}
            handleCloseEventDetailCalander={handleCloseEventDetailCalander}
            backBtn={sidebarBackBtn}
            handleViewMoreEvent={() => {
              handleViewMoreEvent();
            }}
          />
        );
      }}
    >
      <div className="entity-calendar-sheet">
        <div className="calendar-wrapper">
          <div className="filter-container">
            <CustomMultiSelectDropdown
              groupedOptions={filterOptions}
              value={selectedKeys}
              onChange={(e) => {
                handleSelectNode(e.value);
              }}
              applyFilter={handleApplyFilter}
              deSelectAll={handleDeSelect}
              placeholder="All events"
              filterCount={chipData?.length}
              buttonFilter={true}
            />
          </div>
          <Calendar
            localizer={localizer}
            events={items}
            startAccessor="start"
            endAccessor="end"
            selectable
            className={styles.calendar}
            onNavigate={onDateChange}
            components={{
              event: EventComponentWrapper,
              toolbar: (props) => (
                <MyCalendarToolbar
                  {...props}
                  onWidthCalculated={setToolbarButtonsWidth}
                  loading={calendarLoading}
                  chipData={chipData}
                  handleRemoveFilter={handleRemoveFilter}
                />
              ),
            }}
          />
        </div>
      </div>
    </Layout>
  );
};

export default MyCalendar;
